import DefaultList from "@Common/DefaultList";
import { inject, observer } from "mobx-react";
import moment from "moment";
import { confirmDialog } from "primereact/confirmdialog";
import { useRef } from "react";

import "./style.scss";

const UploadedActivations = inject("mainStore")(
    observer(({ mainStore }) => {
        const ref = useRef(null);

        const handleDelete = async (el) => {
            const resp = await mainStore.deleteByUrl(`/promo/activationoffers`, { items: [{ offer_id: el.offer_id, site_id: el.site_id, date: moment(el.date).format("YYYY-MM-DD") }] });
            if (resp && resp.success) {
                ref.current?.getData("/promo/activationoffers");
            }
        };

        const confirmDelete = (e, el) => {
            e.stopPropagation();

            confirmDialog({
                message: `Вы выбрали 1 запись в загруженных активациях`,
                header: "Вы уверены, что хотите удалить?",
                icon: "pi pi-exclamation-triangle",
                defaultFocus: "accept",
                rejectLabel: "Отмена",
                acceptLabel: "Удалить",
                rejectClassName: "p-button-danger",
                accept: () => handleDelete(el),
            });
        };

        return (
            <>
                <DefaultList
                    ref={ref}
                    beforeGetData={() => mainStore.setMainStore("filter.rows", 20)}
                    dataKey={""}
                    apiUrl="/promo/activationoffers"
                    // keysToGet={["partner", "name", "squareLogo", "active", "archived", "draft"]}
                    typeOfHeader="activation"
                    typeOfFooter="activation"
                    isPagination
                    titleName={
                        <>
                            Активации / <span style={{ color: "#757575" }}>Загруженные</span>
                        </>
                    }
                    keyFilterSearch="name"
                    handleRowClick={() => {}}
                    columns={[
                        {
                            field: "vendor.name",
                            header: "Вендор",
                            sortable: true,
                            body: (item) => <span className="list__name">{item?.vendor?.name}</span>,
                            style: { maxWidth: "250px", overflow: "hidden" },
                        },
                        {
                            field: "offer.title",
                            header: "Оффер",
                            sortable: true,
                        },
                        {
                            field: "site.name",
                            header: "Витрина",
                            sortable: true,
                        },
                        {
                            field: "count",
                            header: "Тотал",
                            sortable: true,
                            body: (item) => <b>{item.count}</b>,
                        },
                        {
                            field: "activationsDate",
                            body: (item) => <span>{item.activationsDate ? moment(item.activationsDate).format("DD.MM.YY") : "-"}</span>,
                            header: "Дата",
                            style: { width: "10%", maxWidth: "127px", textOverflow: "ellipsis", overflow: "hidden" },
                            sortable: true,
                        },
                        {
                            field: "",
                            body: (item) => <i className="pi pi-trash" style={{ color: "#EA5455", cursor: "pointer" }} onClick={(e) => confirmDelete(e, item)}></i>,
                            header: "",
                        },
                    ]}
                />
            </>
        );
    }),
);

export default UploadedActivations;
